import { render, staticRenderFns } from "./HuchaTransferirCuentaStep1.vue?vue&type=template&id=b22599e4&scoped=true"
import script from "./HuchaTransferirCuentaStep1.vue?vue&type=script&lang=js"
export * from "./HuchaTransferirCuentaStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22599e4",
  null
  
)

export default component.exports